import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["counter"]

  connect() {
    this.updateCounter()
  }

  toggleCompetency(event) {
    this.updateCounter()
  }

  updateCounter() {
    const checkboxes = this.element.querySelectorAll('input[type="checkbox"]:checked')
    const count = checkboxes.length
    
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = count
    }
    
    // Update alle Counter-Elemente auf der Seite
    const counters = document.querySelectorAll('[data-competency-counter]')
    counters.forEach(counter => {
      counter.textContent = count
    })
  }
} 